import React, { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, Chip
} from '@material-ui/core'
import {
  Description as PlansIcon,
  PhotoLibrary as PhotosIcon,
  Receipt as QuoteIcon,
  AttachMoney as InvoiceIcon,
  InsertDriveFile as FilesIcon,
  CheckCircle as SignedIcon,
  Assignment as BidResponseIcon
} from '@material-ui/icons'

const categories = [
  { key: 'plans', label: 'Plans', icon: PlansIcon, color: '#1976d2' },
  { key: 'bid_response', label: 'Bid Response', icon: BidResponseIcon, color: '#e65100' },
  { key: 'vendor_quote', label: 'Vendor Quote', icon: QuoteIcon, color: '#2e7d32' },
  { key: 'photos', label: 'Photos', icon: PhotosIcon, color: '#7b1fa2' },
  { key: 'vendor_invoice', label: 'Vendor Invoice', icon: InvoiceIcon, color: '#ef6c00' },
  { key: 'signed_estimate', label: 'Signed Estimate', icon: SignedIcon, color: '#00838f' },
  { key: 'files', label: 'Other Files', icon: FilesIcon, color: '#546e7a' }
]

const categoryChipStyle = (color, selected) => ({
  margin: 4,
  padding: '20px 12px',
  fontSize: 14,
  fontWeight: selected ? 700 : 400,
  cursor: 'pointer',
  backgroundColor: selected ? color : '#f5f5f5',
  color: selected ? '#fff' : '#333',
  border: selected ? 'none' : '1px solid #ddd',
  transition: 'all 0.15s ease'
})

/**
 * Step 1 only: ask the user what type of file this is.
 * Once they pick a category and confirm, onCategoryConfirmed fires
 * and the parent handles the actual upload in the background.
 */
export default function UploadCategoryWizard ({ file, remainingCount = 0, onClose, onCategoryConfirmed }) {
  const [selectedCategory, setSelectedCategory] = useState(null)

  const fileSizeMB = file ? (file.size / 1024 / 1024).toFixed(2) : '0'

  const handleConfirm = () => {
    if (!selectedCategory) return
    onCategoryConfirmed(selectedCategory)
  }

  return (
    <Dialog open maxWidth="sm" fullWidth onClose={onClose}>
      <DialogTitle>
        What type of file is this?
        {remainingCount > 0 && (
          <Typography variant="caption" color="textSecondary" style={{ marginLeft: 8 }}>
            ({remainingCount} more after this)
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <Box style={{
          padding: '12px 16px',
          marginBottom: 16,
          backgroundColor: '#f5f5f5',
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          gap: 12
        }}>
          <FilesIcon style={{ color: '#757575', fontSize: 28 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" style={{
              fontWeight: 600,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {file.name}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {fileSizeMB} MB
            </Typography>
          </div>
        </Box>
        <Box style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 8, padding: '8px 0' }}>
          {categories.map(cat => {
            const Icon = cat.icon
            return (
              <Chip
                key={cat.key}
                icon={<Icon style={{ color: selectedCategory === cat.key ? '#fff' : cat.color }} />}
                label={cat.label}
                onClick={() => setSelectedCategory(cat.key)}
                style={categoryChipStyle(cat.color, selectedCategory === cat.key)}
              />
            )
          })}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{remainingCount > 0 ? 'Skip' : 'Cancel'}</Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={!selectedCategory}
        >
          {remainingCount > 0 ? 'Upload & Next' : 'Upload & Continue'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
